import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { Dialog, Text, Alert, useToast } from "@flat-ui";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { SnapshotEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
import { selectedProjectIdSelector } from "@store/projects/projects-selector";
import { deleteProjectSnapshot } from "@store/projects/projects-slice-thunk";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
/** Component allowing user to delete a snapshot through a dialog */
export function DeleteSnapshot({
  snapshot,
  onClose
}) {
  const projectId = useAppSelector(selectedProjectIdSelector);
  const dispatch = useAppDispatch();
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const [isProcessing, setIsProcessing] = useState(false);
  async function deleteSelectedSnapshot() {
    if (projectId) {
      trackEvent({
        name: SnapshotEvents.deleteSnapshot
      });
      setIsProcessing(true);
      try {
        await dispatch(deleteProjectSnapshot({
          projectId,
          snapshotId: snapshot.id
        })).unwrap();
        openToast({
          title: "Snapshot deleted successfully"
        });
      } catch (error) {
        handleErrorWithToast({
          id: `ProjectSnapshots-deleteSnapshot-${Date.now().toString()}`,
          title: "Could not delete project snapshot",
          error
        });
      } finally {
        setIsProcessing(false);
      }
    }
  }
  return <>
      {/* Dialog to confirm before delete */}
      <Dialog title="Delete Snapshot" confirmText="Delete" open={true} onConfirm={deleteSelectedSnapshot} disabled={isProcessing} onCancel={onClose} showSpinner={isProcessing} variant="danger">
        <Text sx={{
        fontSize: "14px",
        mb: SPACE_ELEMENTS_OF_MODAL
      }} variant="bodyM">
          When deleting the{" "}
          <var>
            <b>{snapshot.name}</b>
          </var>{" "}
          snapshot, all data will be lost.
        </Text>

        <Alert variant="warning" title="Deleted snapshots cannot be recovered." />
      </Dialog>
    </>;
}